import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { patchApiData } from "../helpers/AxiosInstance";

interface PatchDailyNoteArgs {
  url: string;
  formData: any;
  setError?: (name: string, error: any) => void;
}

const DAILY_NOTE_LIST_KEY = ["daily-note"];

const useDailyNotePatch = (navigateURL = "/daily-notes") => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ url, formData }: PatchDailyNoteArgs) =>
      patchApiData({ url, formData }),

    onSuccess: (response, variables) => {
      if (response.status !== 200 && response.status !== 201) {
        toast.error(response?.data?.message ?? "Something went wrong");
        return;
      }

      const updatedNote = response.data;

      toast.success("Daily note updated successfully");

      queryClient.setQueryData(DAILY_NOTE_LIST_KEY, (oldData: any) => {
        if (!oldData?.results) return oldData;

        return {
          ...oldData,
          results: oldData.results.map((note: any) =>
            note.id === updatedNote.id ? updatedNote : note
          ),
        };
      });

      queryClient.setQueryData(
        ["daily-note", `daily-note-${updatedNote.id}`],
        updatedNote
      );

      queryClient.invalidateQueries({ queryKey: DAILY_NOTE_LIST_KEY });

      navigate(navigateURL);
    },

    onError: () => {
      toast.error("Something went wrong");
    },
  });
};

export default useDailyNotePatch;

